<template>
  <div class="stepper-wrapper">
    <div class="stepper-header-modern">
      <div
        v-for="(step, idx) in steps"
        :key="step.key"
        class="step-item"
        :class="{
          active: modelValue === idx,
          completed: modelValue > idx,
          pending: modelValue < idx
        }"
        @click="onClick(idx)"
      >
        <div class="step-circle">
          <i v-if="modelValue > idx" class="fa-solid fa-check"></i>
          <span v-else>{{ idx + 1 }}</span>
        </div>

        <div class="step-label">{{ step.title }}</div>

        <div class="step-line" v-if="idx < steps.length - 1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseStepper",
  props: {
    steps: { type: Array, required: true },
    modelValue: { type: Number, required: true }, // v-model
    allowForward: { type: Function, default: null } // validation hook
  },
  emits: ["update:modelValue"],
  methods: {
    onClick(idx) {
      if (idx === this.modelValue) return;

      // Going back is always allowed
      if (idx < this.modelValue) {
        this.$emit("update:modelValue", idx);
        return;
      }

      // Forward navigation validation
      if (this.allowForward) {
        const ok = this.allowForward(this.modelValue, idx);
        if (!ok) return;
      }

      this.$emit("update:modelValue", idx);
    }
  }
};
</script>

<style>
    /* === STEPPER HEADER === */
.stepper-header-modern {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.step-item {
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.step-item.active,
.step-item.completed {
  opacity: 1;
}

.step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: white;
  border: 2px solid #e0e0e0;
  color: var(--text-grey);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  z-index: 2;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.step-item.active .step-circle {
  background: var(--primary-bright);
  color: #fff;
  border-color: var(--primary-bright);
  box-shadow: 0 0 0 5px rgba(0, 123, 255, 0.2);
  transform: scale(1.1);
}

.step-item.completed .step-circle {
  background: var(--primary-dark);
  color: #fff;
  border-color: var(--primary-dark);
}

.step-label {
  margin-left: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--primary-dark);
  white-space: nowrap;
}

.step-line {
  flex: 1;
  height: 3px;
  background: #e0e0e0;
  margin: 0 15px;
  border-radius: 2px;
}

.step-item.completed .step-line {
  background: var(--primary-dark);
}

</style>